import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  value: {
    steps: [
      {
        mobileName: "Start",
        name: "How can we help?",
        url: "/choose-path",
        completed: false,
      },
      {
        mobileName: "Investment Vehicle",
        name: "Select your investment vehicle",
        url: "/investment-select",
        completed: false,
      },
      {
        mobileName: "Investment Solution",
        name: "Choose your investment solution",
        url: "/investment-solution",
        completed: false,
      },
      {
        mobileName: "Details & Review",
        name: "Complete your details",
        url: "/details",
        completed: false,
      },
      {
        mobileName: "Finalise",
        name: "Finalise your Investment",
        url: "/finalise",
        completed: false,
      },
    ],
    requireHelp: false,
    active: 0,
    failed: [],
    skipped: [],
  },
};

export const stepperSlice = createSlice({
  name: "stepper",
  initialState,
  reducers: {
    setRequireHelp: (state, action) => {
      state.value.requireHelp = action.payload;
    },
    updateStep: (state, action) => {
      state.value.active = action.payload;
    },
    completeStep: (state, action) => {
      state.value.steps[action.payload].completed = true;
    },
    failStep: (state, action) => {
      state.value.failed.push(action.payload);
    },
    skipStep: (state, action) => {
      state.value.skipped.push(action.payload);
    },
    resetSteps: () => initialState,
  },
});

export const {
  updateStep,
  completeStep,
  failStep,
  skipStep,
  resetSteps,
  setRequireHelp,
} = stepperSlice.actions;

export default stepperSlice.reducer;
